import React from "react"
import {
  Flex, Heading, Stack, Text,
} from "@chakra-ui/react"
import Modal from "components/dialogs/Modal"
import Icon from "components/elements/Icon"
import ConfettiExplosion from "components/ConfettiExplosion"
import Button from "components/Buttons/Button"

type Props = {
  onHide: () => void
}

export const UpgradeSuccessful = ({ onHide }: Props) => {
  const handleClickContinue = () => onHide()

  return (
    <ConfettiExplosion>
      <Modal
        show
        hide={onHide}
        enableOverlay={false}
        size="lg"
        closeOnEsc={false}
        header={<></>}
      >
        <Stack alignItems="center" textAlign="center" spacing={8}>
          <Flex alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
            <Icon size={14} icon="portal-confirmed" color="blue.500" />
            <Heading size="lg" fontWeight="semibold">Upgrade Successful</Heading>
          </Flex>
          <Stack spacing={2} mb={4}>
            <Text fontSize="lg">Thank you! Your plan has been upgraded successfully.</Text>
            <Text fontSize="lg">You can find your receipt in <b>Account &gt; Plan & Billing</b>.</Text>
          </Stack>
          <Button onClick={handleClickContinue} size="lg" px={10}>Continue</Button>
        </Stack>
      </Modal>
    </ConfettiExplosion>
  )
}

export default UpgradeSuccessful
